import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RearchHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      className="
        relative
        min-h-screen
        
        bg-[url('/researchmobile.webp')]   /* Mobile Image */
        md:bg-[url('/research.webp')]       /* Desktop Image */
        
        bg-cover
        bg-center
        bg-no-repeat
        flex
        items-center
      "
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/30"></div>

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-7 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-15">
          
          {/* Left Content */}
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-semibold leading-tight">
              {t("research_hero_title")}
            </h1>

            <p className="mt-2 text-white/80 max-w-xl text-xl">
              {t("research_hero_subtitle")}
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="bg-white/10 backdrop-blur-md px-5 py-4 rounded-lg">
                <p className="text-2xl font-semibold">+25%</p>
                <p className="text-sm text-white/70 mt-1">
                  {t("research_hero_stat_yield")}
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-md px-5 py-4 rounded-lg">
                <p className="text-xl font-medium">
                  {t("research_hero_stat_realtime")}
                </p>
                <p className="text-sm text-white/70 mt-1">
                  {t("research_hero_stat_climate")}
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-md px-5 py-4 rounded-lg">
                <p className="text-xl font-medium">
                  {t("research_hero_stat_energy")}
                </p>
                <p className="text-sm text-white/70 mt-1">
                  {t("research_hero_stat_optimization")}
                </p>
              </div>
            </div>

            {/* Links */}
            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to="/"
                className="bg-[#7EDE56] hover:bg-[#002F3F] transition px-7 py-3 rounded-lg text-md font-medium inline-block"
              >
                {t("research_hero_link_about")}
              </Link>

              <Link
                to="/contact"
                className="border border-white/40 hover:bg-white/10 transition px-7 py-3 rounded-full text-md font-medium inline-block"
              >
                {t("research_hero_link_contact")}
              </Link>
            </div>
          </div>

          {/* Right side empty */}
          <div className="hidden lg:block"></div>
        </div>
      </div>
    </section>
  );
};

export default RearchHero;
